// 设备管理
export default {
    devmanage: "device management",
    uavdevdetails: 'Equipment details (UAV)',
    life: 'Life statistics',
    ptzdevdetails: 'Equipment details (PTZ)',
    battydevdetails: 'Device details (smart battery)',
    rtkdevdetails: 'Equipment details (RTK)',
    sn: 'SN',
    devname: 'Equipment Name',
    pinputname: 'Please enter the device name',
    pinputsn: 'Please enter the SN code of the device',
    search: 'search',
    adddev: 'Add Device',
    devtype: 'Equipment Type',
    devstate: 'Equipment Status',
    networkstate: 'Network Status',
    screen: 'Screen',
    devnum: 'Number of equipment',
    inputtime: 'Entry Time',
    vision: 'Version No',
    dtime: 'Delivery Time',
    Atime: 'Activation time',
    SS: 'Share Status',
    QXA: 'Qianxun Account',
    operation: 'Operation',
    details: 'Details',
    edit: 'Edit',
    share: 'Share',
    QX: 'Qian Xun',
    delete: 'Delete',
    editdev: 'Edit device',
    devsn: 'Equipment',
    deletes: 'Bulk delete',
    remarks: 'Remarks',
    uav: 'UAV',
    znBattery: 'Smart battery',
    ptz: 'PTZ',
    normal: 'normal',
    reparied: 'To be repaired',
    under: 'Under maintenance',
    scrap: 'Scrap',
    onlin: 'on-line',
    offline: "off-line",
    psearch: 'Please search first',
    deldevmes: 'You will not be able to use the device after deleting it, do you want to continue?',
    delchedevmes: 'You will not be able to use the selected device after deletion, do you want to continue?',
    SU: 'Shared users',
    mobile: 'Mobile',
    Battery: 'Battery',
    flymodel: 'UAV Model',
    Batterymodel: 'Battery model',
    defects: 'defects liability period',
    BMSv: 'BMS version',
    totaltime: 'Total usage time',
    cffreq: 'Charge and discharge times',
    reslife: 'residual life',
    usefullife: 'Useful life',
    batterylife: "Battery life statistics",
    ptzmodel: 'Model of PTZ',
    day: 'days',
    firmv: 'Firmware version',
    rtk: 'base station',
    model: 'model',
    long: 'longitude',
    lat: 'latitude',
    basertk: 'Base station altitude',
    coverage: 'Coverage',
    satenum: 'Number of satellites',
    positionlong: 'positioning accuracy',
    positiontype: 'Location status',
    NS: 'Networking status',
    flysn: 'aircraft',
    flynum: 'Number of flights',
    EAV: 'EAV',
    flytotaltime: 'Total flight time',
    lifestatistic: 'Life statistics',
    Flightv: 'Flight control version',
    gatewayv: 'Gateway version',
    Fligh: 'Flight control',
    gateway: 'Gateway',
    radar: 'Ground to ground radar',
    receiver: 'Receiver',
    parachute: 'parachute',
    elemach: 'electric machinery',
    elereg: 'Electrical regulation',
    motor: 'motor',
    totalflightmil: 'Total flight mileage',
    uavlifestatistic: 'UAV life statistics',
    parachuteLife: 'Parachute Life',
    armNumber: 'Arm {0}',
    AS: 'Already Shared',
    WS: 'Was Shared',
    month: 'Month',
    tip_DP: 'Duplicate device name, please re-enter',
}